import {IObserverApp} from './IObserverApp';

export class ObserverApp implements IObserverApp {
  _observer:any = null;
  _reference:any = null;
  _readyCallback:any = null;
  _isAttached:boolean = false;
  _appName:string = 'genericObserverApp';
  _listeners:any = [];

  constructor(public appName:string = 'genericObserverApp', public readyCallback: any = (() => {})) {
      this._readyCallback = readyCallback;
      this._appName = appName;
      this.attachToObserver();
  }

  private attachToObserver():void {
    window['Observables'] = window['Observables'] || {
     apps: []
   };

   window['Observables'].apps.push({
     instance: this,
     name: this._appName
   })
  }

  public async ObserverReady (app:any, observer:any):Promise<void> {
      this._observer = observer;
      this._reference = app;

      if (this._readyCallback)
        await this._readyCallback(this);
  }

  public DetachingApp(app:any, observer:any): void {
      this._isAttached = false;

      for (let i = 0; i < this._listeners.length; i++) {
        let listener = this._listeners[i];
        app.detachListenerByUID(listener.uid);
      }
  }

  public getReference():any {
    return this._reference;
  }

  public getObserver():any {
    return this._observer;
  }

  private pushListenerInStack(listener:any):void {
    if (!listener || !listener.uid)
      return;

    this._listeners.push(listener)
  }

  private removeListenerFromStack(listener:any):void {
    if (!listener || !listener.uid)
      return;

    this._listeners = this._listeners.filter((item:any) => {
      if (item.uid == listener.uid)
        return false;

      return true;
    });
  }

  public async attach(eventName:string , callback: any):Promise<string> {
    let id = this.getReference().attachListener(eventName, callback);

    this.pushListenerInStack({
      uid: id,
      eventName,
      callback
    });

    return id;
  }

  public async once(eventName:string , callback: any):Promise<string> {
    let id = this.getReference().once(eventName, callback);

    this.pushListenerInStack({
      uid: id,
      eventName,
      callback
    });

    return id;
  }

  public async detach(eventName: string):Promise<void> {
    let listOfEvents = this._listeners.filter((item:any) => {
      if (item.eventName == eventName)
        return true;

      return false;
    });

    for (let i = 0; i < listOfEvents.length; i++) {
      await this.detachByUID(listOfEvents[i].uid);
    }
  }

  public async detachByUID(uid: string):Promise<void> {
    await this.getReference().detachListenerByUID(uid);
    this.removeListenerFromStack({uid})
  }

  public async trigger(eventName:string, ...args:any[]):Promise<void> {
    let resp = await this.getObserver().trigger(eventName, ...args);
    return resp;
  }
}
